import {IcePhenomena} from '../operational/input/kn15-telegram/ice-phenomena';
import {IIcePhenomena} from '../operational/input/kn15-telegram/kn15-parse.service';
import {IDataValue} from '../api/api.types';

export interface IIcePhenomenarFormatter {
  (value:string|number, defaultText?:string):string;
}

export default function IcePhenomenaFormatter($translate: ng.translate.ITranslateService) {
  return (input: IDataValue[], defaultText:string = '---'): string => {
    if (!input) {
      return defaultText;
    }


    let icePhenomenae: String[] = [];

    angular.forEach(input, function (inputValue: IDataValue) {
        icePhenomenae.push(parse(inputValue));
    });

    function parse (inputValue: IDataValue) { 

        if (inputValue.dataValue === null) {
            return defaultText;
        }
        const value = Number.parseFloat(inputValue.dataValue.toString());
        if (Number.isNaN(value)) {
            return defaultText;
        }

        const icePhenomenaCode = value.toFixed(0);
        const icePhenomenaName = $translate.instant(`ICE_PHENOMENA_${icePhenomenaCode}`);


        let icePhenomenaIntensity: number|string = (value % 1) * 1000;

        if (inputValue.dataValue.toString().indexOf('.') !== -1) {
            icePhenomenaIntensity = icePhenomenaIntensity.toFixed(0) + '%';    
        } else {
            icePhenomenaIntensity = defaultText;
        }
        
        return icePhenomenaName + ' (' + icePhenomenaIntensity + ')';

    }

    return icePhenomenae.join(', ');
  };
}
IcePhenomenaFormatter.$inject = ['$translate'];




/** WEBPACK FOOTER **
 ** ./app/utils/ice-phenomena.formatter.ts
 **/